// The resolver never emits a zero-hour bucket, so a present type is one this row's
// typeSummaries actually contains, not one whose hours happen to be non-zero.
export const isTypePresentOnRow = (row, timeTypeId) => {
  return (row.typeSummaries || []).some(typeSummary => typeSummary.timeTypeId === timeTypeId)
}

export default isTypePresentOnRow
